var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_686_3357",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.87881C7 1.20937 7.54269 0.666687 8.21212 0.666687H11.8485C12.5179 0.666687 13.0606 1.20937 13.0606 1.87881C13.0606 2.25293 13.548 3.09093 14.8788 3.09093C16.2096 3.09093 16.697 2.25293 16.697 1.87881C16.697 1.20937 17.2397 0.666687 17.9091 0.666687H21.5455C22.2149 0.666687 22.7576 1.20937 22.7576 1.87881V20.0606C22.7576 20.7301 22.2149 21.2727 21.5455 21.2727H17.9091C17.2397 21.2727 16.697 20.7301 16.697 20.0606C16.697 19.6346 16.2341 18.8485 14.8788 18.8485C14.2094 18.8485 13.6667 18.3058 13.6667 17.6364C13.6667 16.9669 14.2094 16.4243 14.8788 16.4243C16.6992 16.4243 18.316 17.3749 18.8948 18.8485H20.3333V3.09093H18.8826C18.2972 4.52164 16.7035 5.51517 14.8788 5.51517C13.0541 5.51517 11.4604 4.52164 10.8749 3.09093H9.42424V10.3637C9.42424 11.0331 8.88156 11.5758 8.21212 11.5758C7.54269 11.5758 7 11.0331 7 10.3637V1.87881Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8789 26.1212H11.2425C11.2425 24.8364 10.0304 23.697 8.2122 23.697C6.39402 23.697 5.1819 24.8364 5.1819 26.1212H1.54553V7.93939H5.1819C5.1819 9.15151 6.39402 10.3636 8.2122 10.3636C10.0304 10.3636 11.2425 9.15151 11.2425 7.93939H14.8789V26.1212Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333374 7.93942C0.333374 7.26998 0.876059 6.72729 1.5455 6.72729H5.18186C5.85129 6.72729 6.39398 7.26998 6.39398 7.93942C6.39398 8.31354 6.88139 9.15154 8.21216 9.15154C9.54294 9.15154 10.0303 8.31354 10.0303 7.93942C10.0303 7.26998 10.573 6.72729 11.2425 6.72729H14.8788C15.5483 6.72729 16.0909 7.26998 16.0909 7.93942V26.1212C16.0909 26.7907 15.5483 27.3334 14.8788 27.3334H11.2425C10.573 27.3334 10.0303 26.7907 10.0303 26.1212C10.0303 25.6952 9.5675 24.9091 8.21216 24.9091C6.85682 24.9091 6.39398 25.6952 6.39398 26.1212C6.39398 26.7907 5.85129 27.3334 5.18186 27.3334H1.5455C0.876059 27.3334 0.333374 26.7907 0.333374 26.1212V7.93942ZM2.75762 9.15154V24.9091H4.19618C4.77495 23.4355 6.39177 22.4849 8.21216 22.4849C10.0326 22.4849 11.6494 23.4355 12.2281 24.9091H13.6667V9.15154H12.216C11.6306 10.5822 10.0368 11.5758 8.21216 11.5758C6.38748 11.5758 4.79376 10.5822 4.2083 9.15154H2.75762Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18185 15.2121C5.85128 15.2121 6.39397 14.6695 6.39397 14C6.39397 13.3306 5.85128 12.7879 5.18185 12.7879C4.51241 12.7879 3.96973 13.3306 3.96973 14C3.96973 14.6695 4.51241 15.2121 5.18185 15.2121Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21212 15.2121C8.88156 15.2121 9.42424 14.6695 9.42424 14C9.42424 13.3306 8.88156 12.7879 8.21212 12.7879C7.54269 12.7879 7 13.3306 7 14C7 14.6695 7.54269 15.2121 8.21212 15.2121Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2424 15.2121C11.9118 15.2121 12.4545 14.6695 12.4545 14C12.4545 13.3306 11.9118 12.7879 11.2424 12.7879C10.573 12.7879 10.0303 13.3306 10.0303 14C10.0303 14.6695 10.573 15.2121 11.2424 15.2121Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_686_3357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.30298 -0.54541H25.7879V28.5455H-3.30298V-0.54541Z",
    fill: "#0073BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash2);
export default __webpack_public_path__ + "static/media/dash2.adb519ef9556ab91ad21df3eeeabab75.svg";
export { ForwardRef as ReactComponent };